
class NavRedirects {
  
  pathsToRedirect = new Map<string, string>()
  .set('/unsplash', '/#unsplash-for-confluence')
  .set('/unsplash/privacy', '/#unsplash-for-confluence-privacy')
  .set('/unsplash/contact', '/#unsplash-for-confluence-user-guide');

    execute = () => {
      const path = window.location.pathname;
      const redirect = this.pathsToRedirect.get(path);
      if (redirect) {
        window.location.replace(redirect);
      }
    }

}

const navRedirects = new NavRedirects();
export default navRedirects;
